<template>
  <div v-show="isShow" class="calibrate-chat-container">
    <div v-if="score !== null" class="calibrate-chat-score">
      <p class="calibrate-chat-score_info" :class="`status-${scoreStatus}`">
        {{ scoreText }}
      </p>
      <!-- <p>{{ $t('deviceMsg.goodness') }}: {{ score }}</p> -->
    </div>
    
    <div ref="chat" class="calibrate-chat" />
  </div>
</template>

<script>
import echarts from 'echarts';
import { calculateLinearFitScore, calculateLinearRegression, prepareChartData, calculateFitScore, RELAX_FACTOR, recommendOptimalY } from './utils';
import { linearRegressionSolve, Point } from './utils2';

const DEFAULT_OPTIONS = {
  HIGH: 80,
  MEDIUM: 60,
}

// function getMinMaxValues(data, key) {
//     if (!Array.isArray(data) || data.length === 0) {
//         return { min: null, max: null };
//     }
    
//     // 提取所有Value值
//     const values = data.map(item => item[key]);
    
//     // 计算最小值和最大值
//     const min = Math.min(...values);
//     const max = Math.max(...values);
    
//     return { min, max };
// };

export default {
  name: 'CalibrateChat',
  props: {
    data: {
      type: Array,
      default: () => ([]),
    },
    newData: {
      type: Array,
      default: () => ([]),
    },
    calibrateRealtimeValue: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      recommendedY: null,
      isShow: true,
      chart: null,
      option: {},
      score: 0,
      scoreStatus: 1,
      scoreText: this.$t('deviceMsg.excellent'),
      data1: []
    }
  },

  computed: {
    allList() {
      return this.data.concat(this.newData);
    },

    list() {
      const allNewDataLength = this.newData.length;
      const hasDataList = this.newData.filter(
        item => item.CorrectionValue !== undefined && item.CorrectionValue !== ''
      );

      const newData = hasDataList.map(item => {
        return {
          Value: Number(item.Value || this.calibrateRealtimeValue) || 0,
          CorrectionValue: Number(item.CorrectionValue) || 0,
          isNew: false
        };
      });

      // 全部填满
      if (allNewDataLength === hasDataList.length && newData[allNewDataLength - 1]) {
        newData[allNewDataLength - 1].isNew = true;
      }

      // const newData = this.newData.map(item => {
      //   return {
      //     Value: Number(item.Value || this.calibrateRealtimeValue) || 0,
      //     CorrectionValue: Number(item.CorrectionValue) || 0,
      //     isNew: true
      //   }
      // });

      return this.data.concat(newData);
        
    }
  },

  watch: {
    list() {
      this.handlerChat();
    },
  },

  mounted() {
    this.handlerChat();
  },
  beforeDestroy() {
  },
  methods: {
    handlerChat() {
      this.chart = echarts.init(this.$refs['chat']);

      // const data2 = [
      //   { Value: 90, CorrectionValue: 89 },
      //   { Value: 92, CorrectionValue: 90 },
      //   { Value: 96, CorrectionValue: 94 },
      //   { Value: 100, CorrectionValue: 98 },
      //   // { Value: 105, CorrectionValue: 202 },
      // ];

      const data = this.list
        .map(item => {
          return {
              Value: item.CorrectionValue,
              CorrectionValue: item.Value,
              isNew: item.isNew,
              // Value: item.Value,
              // CorrectionValue: item.CorrectionValue,
              // isNew: item.isNew,
            }
      }).sort((pre, next) => pre.Value - next.Value);

      //  const data = [
      //   { Value: 90, CorrectionValue: 45 },
      //   { Value: 100, CorrectionValue: 54 },
      //   { Value: 200, CorrectionValue: 110 },
      //   { Value: 400, CorrectionValue: 203 },
      //   { Value: 600, CorrectionValue: 400 },
      // ];

      // const data = [
      //   { Value: 45, CorrectionValue: 90 },
      //   { Value: 50, CorrectionValue: 100 },
        // { Value: 55, CorrectionValue: 110 },
        // { Value: 200, CorrectionValue: 110 },
        // { Value: 400, CorrectionValue: 203 },
        // { Value: 600, CorrectionValue: 400 },
      // ];
      
      if (this.allList.length < 3) {
         this.score = 0;
         this.$emit('recommendedY', null);
      }

      if (data.length < 2) {
        this.scoreText = '';
        this.score = 0;
        this.isShow = false;
        return;
      }

      // const points = data.map(item => new Point(item.Value, item.CorrectionValue));
      const points = data.map(item => new Point(item.CorrectionValue, item.Value));
      this.isShow = true;

      // 计算回归系数
      const regression = linearRegressionSolve(points);
      // const regression = calculateLinearRegression(data);
      const fitScore = calculateFitScore(data, regression, RELAX_FACTOR);
      const chartData = prepareChartData(data, regression);
      // 获取推荐值 第一个参数是所有已有的数据，第二个数据是当前x值
      const recommand = recommendOptimalY(data.filter(item => item.isNew !== true), Number(this.calibrateRealtimeValue), {
        // yRange: [最小值, 最大值], // 可选
        step: 0.1, // 可选，搜索精度
        includeDetails: true // 可选，是否包含详细分析
      });

      if (!!recommand && recommand.recommendedY && this.allList.length > 2) {
        // this.recommendedY = recommand.recommendedY;
        // this.$emit('recommendedY', Math.floor(recommand.recommendedY));
        this.$emit('recommendedY', null);
      } else {
        this.$emit('recommendedY', null);
      }

      this.score = data.length === 2 ? null : (fitScore.score || 0);

      if (this.score >= DEFAULT_OPTIONS.HIGH) {
        this.scoreText = this.$t('deviceMsg.excellent');
        this.scoreStatus = 1;
      }

      if (this.score < DEFAULT_OPTIONS.HIGH && this.score >= DEFAULT_OPTIONS.MEDIUM) {
        this.scoreText = this.$t('deviceMsg.makeDo');
        this.scoreStatus = 2;
      }

      if (this.score < DEFAULT_OPTIONS.MEDIUM) {
        this.scoreText = this.$t('deviceMsg.poor');
        this.scoreStatus = 3;
      }

      if (this.score === null) {
        this.scoreText = ''
        this.scoreStatus = 3;
      }

      // 初始化 ECharts 实例
      // const chartDom = document.getElementById('chart-container'); // 确保HTML中有这个元素
      // const myChart = echarts.init(chartDom);

      // 配置项
      const option = {
          // title: {
          //     text: '线性回归分析',
          //     subtext: `回归方程: y = ${regression.a.toFixed(4)}x + ${regression.b.toFixed(4)}`,
          //     left: 'center'
          // },
          tooltip: {
              trigger: 'axis',
              formatter: (params) => {
                  if (params.length > 1) {
                      return `${this.$t('deviceMsg.tropic')}<br/>x: ${params[0].value[0].toFixed(2)}<br/>y: ${params[0].value[1].toFixed(2)}`;
                  }
                  const point = params[0];
                  return `${this.$t('deviceMsg.rawData')}<br/>x: ${point.value[0]}<br/>y: ${point.value[1]}`;
              }
          },
          legend: {
              data: [this.$t('deviceMsg.rawData'), this.$t('deviceMsg.tropic')],
              top: 30
          },
          grid: {
              left: '10%',
              right: '10%',
              bottom: '15%',
              top: '20%'
          },
          xAxis: {
              // name: 'CorrectionValue (x)',
              nameLocation: 'middle',
              nameGap: 25,
              type: 'value',
              scale: true,
              // min: 0,
              // max: 3000,
              min: Math.max(Math.floor(chartData.xMin) - 100, 0),  // 留一些边距
              max: Math.ceil(chartData.xMax) + 100
          },
          yAxis: {
              name: 'Value (y)',
              // name: 'Value (y)',
              nameLocation: 'middle',
              nameGap: 40,
              type: 'value',
              scale: true,
              min: function() {
                // return 0;
                  // const yValues = data.map(item => item.Value);
                  // return Math.min(...yValues) * 0.95;

                return Math.max(Math.floor(chartData.yMin) - 100, 0)
              },
              max: function() {
                // return 3000;
                  // const yValues = data.map(item => item.Value);
                  // return Math.max(...yValues) * 1.05;
                return Math.ceil(chartData.yMax) + 100
              }
          },
          series: [
              {
                  name: this.$t('deviceMsg.rawData'),
                  type: 'scatter',
                  data: chartData.scatterData,
                  symbolSize: 10,
                  itemStyle: {
                      color: '#5470c6'
                  },
                  emphasis: {
                      label: {
                          show: true,
                          position: 'top',
                          formatter: function(params) {
                              return `(${params.value[0]}, ${params.value[1]})`;
                          }
                      }
                  }
              },
              {
                  name: this.$t('deviceMsg.tropic'),
                  type: 'line',
                  data: chartData.lineData,
                  smooth: false,
                  lineStyle: {
                    color: '#ee6666',
                    width: 2,
                    type: 'solid'
                  },
                  symbol: 'none',  // 不显示线的端点符号
                  tooltip: {
                      show: true
                  },
                  markLine: {
                      silent: true,
                      lineStyle: {
                        color: '#ee6666',
                        width: 2,
                        type: 'solid'
                      },
                      data: []
                  }
              }
          ]
      };

      this.chart.setOption(option);
    },
  },
}
</script>

<style lang="scss" scoped>
.calibrate-chat-container {
  width: 100%;
  height: 300px;
}

.calibrate-chat {
  width: 100%;
  height: 100%;
  transform: translateY(-10px);
}
.calibrate-chat-score {
  display: flex;
  align-items: end;
  transform: translateY(10px);

  &_info {
    margin-right: 10px;
    font-size: 16px;
    font-weight: bold;

    &.status-1 {
      color: green;
    }

    &.status-2 {
      color: #ff7900;
    }

    &.status-3 {
      color: red;
    }
  }
}
</style>
